import client, { endpoints } from '../api/client';
import { MEMBERSHIPS } from '../constants/actionTypes';

export const fetchMemberships = (params = {}) => async (dispatch) => {
  dispatch({ type: MEMBERSHIPS.LIST_REQUEST });
  try {
    const { data } = await client.get(endpoints.memberships, { params });
    dispatch({ type: MEMBERSHIPS.LIST_SUCCESS, payload: data });
  } catch (e) {
    dispatch({ type: MEMBERSHIPS.LIST_FAILURE, payload: e.response?.data?.error || e.message });
  }
};

export const fetchMembership = (id) => async (dispatch) => {
  try {
    const { data } = await client.get(endpoints.membershipById(id));
    dispatch({ type: MEMBERSHIPS.GET_SUCCESS, payload: data.membership });
    return data.membership;
  } catch (e) { return null; }
};

export const submitLead = (payload) => async () => {
  try {
    const { data } = await client.post(endpoints.leads, payload);
    return { ok: true, lead: data.lead };
  } catch (e) {
    return { ok: false, error: e.response?.data?.error || e.message };
  }
};
